<p-toast></p-toast>
<p-confirmDialog
  [style]="{ width: '50vw' }"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<router-outlet></router-outlet>
<app-loading></app-loading>
